/*
 * Celvoir swatches — vervangt Globo Color Swatch.
 * 1. Collectiepagina's: variantfoto in elk kleurrondje van de productkaart.
 * 2. Snel toevoegen / upsells / productpagina: variantfoto in elk kleurrondje,
 *    op basis van de product-JSON die het theme al meestuurt.
 * (Op de productpagina zet snippets/celvoir-swatch-images.liquid het ook al server-side.)
 */
(function () {
  'use strict';

  var scheduled = false;
  var jsonCache = typeof WeakMap === 'function' ? new WeakMap() : null;

  function thumb(src, size) {
    if (!src) return '';
    try {
      var url = new URL(src, window.location.origin);
      url.searchParams.set('width', String(size));
      url.searchParams.set('height', String(size));
      url.searchParams.set('crop', 'center');
      return url.href;
    } catch (e) {
      return src;
    }
  }

  function setSwatch(el, src, size) {
    el.style.setProperty('--swatch', 'url("' + thumb(src, size).replace(/"/g, '%22') + '")');
  }

  function productJson(script) {
    if (jsonCache && jsonCache.has(script)) return jsonCache.get(script);
    var data = null;
    try { data = JSON.parse(script.textContent); } catch (e) {}
    if (jsonCache) jsonCache.set(script, data);
    return data;
  }

  function findProductJson(el) {
    var node = el;
    while (node && node !== document.documentElement) {
      var script = node.querySelector && node.querySelector('script[data-product-json]');
      if (script) return productJson(script);
      node = node.parentElement;
    }
    return null;
  }

  function variantImage(variant) {
    if (!variant) return '';
    if (variant.featured_image && variant.featured_image.src) return variant.featured_image.src;
    if (variant.featured_media && variant.featured_media.preview_image) return variant.featured_media.preview_image.src;
    return '';
  }

  function applyGrid() {
    document.querySelectorAll('grid-swatch [data-swatch-image]:not([data-cv-swatch])').forEach(function (el) {
      var src = el.getAttribute('data-swatch-image');
      el.setAttribute('data-cv-swatch', '');
      if (src) setSwatch(el, src, 96);
    });
  }

  function applySelectors() {
    document.querySelectorAll('.radio__fieldset--swatches').forEach(function (fieldset) {
      var labels = fieldset.querySelectorAll('radio-swatch label[data-swatch]:not([data-cv-swatch])');
      if (!labels.length) return;

      var wrapper = fieldset.closest('[data-option-position]');
      var index = wrapper ? Number(wrapper.getAttribute('data-option-position')) - 1 : -1;
      var product = findProductJson(fieldset);

      labels.forEach(function (label) {
        label.setAttribute('data-cv-swatch', '');
        if (!product || !product.variants || index < 0) return;
        /* Veiligheid: alleen als dit rondje echt bij dit product hoort */
        var forAttr = label.getAttribute('for') || '';
        if (product.id && forAttr.indexOf(String(product.id)) === -1) return;
        var value = label.getAttribute('data-swatch');
        var src = '';
        for (var i = 0; i < product.variants.length; i++) {
          var variant = product.variants[i];
          if (variant.options && variant.options[index] === value) {
            src = variantImage(variant);
            if (src) break;
          }
        }
        if (src) setSwatch(label, src, 200);
      });
    });
  }

  /*
   * Snelheid: de theme-grid-swatch downloadt per productkaart de volledige productdata
   * (~50 KB per product). Op telefoons is alleen "8 couleurs" zichtbaar, dus:
   * - het aantal kleuren komt nu uit de pagina zelf (data-cv-color-count)
   * - <cv-grid-swatch> wordt pas een echte <grid-swatch> bij hover met een muis
   *   (of direct, als het swatch-stijl altijd zichtbaar is).
   */
  var swatchStyle = (window.theme && window.theme.settings && window.theme.settings.collectionSwatchStyle) || '';
  var lazySwatches = swatchStyle === 'text' || swatchStyle === 'text-slider';

  function colorCountText(n) {
    var strings = (window.theme && window.theme.strings) || {};
    return n + ' ' + (n > 1 ? (strings.otherColor || 'couleurs') : (strings.oneColor || 'couleur'));
  }

  function upgradeSwatch(lazy) {
    if (!lazy || !lazy.parentNode) return;
    var real = document.createElement('grid-swatch');
    for (var i = 0; i < lazy.attributes.length; i++) {
      real.setAttribute(lazy.attributes[i].name, lazy.attributes[i].value);
    }
    lazy.parentNode.replaceChild(real, lazy);
  }

  function applyCounts() {
    document.querySelectorAll('[data-cv-color-count]:not([data-cv-counted])').forEach(function (el) {
      el.setAttribute('data-cv-counted', '');
      var n = Number(el.getAttribute('data-cv-color-count')) || 0;
      if (n > 0) el.textContent = colorCountText(n);
    });
  }

  function applyLazySwatches() {
    document.querySelectorAll('cv-grid-swatch:not([data-cv-bound])').forEach(function (lazy) {
      lazy.setAttribute('data-cv-bound', '');
      if (!lazySwatches) {
        upgradeSwatch(lazy);
        return;
      }
      var item = lazy.closest('[data-grid-item]') || lazy.parentNode;
      var trigger = function (event) {
        if (event.pointerType && event.pointerType !== 'mouse') return;
        item.removeEventListener('pointerenter', trigger);
        item.removeEventListener('focusin', trigger);
        upgradeSwatch(lazy);
      };
      item.addEventListener('pointerenter', trigger);
      item.addEventListener('focusin', trigger);
    });
  }

  function apply() {
    scheduled = false;
    applyCounts();
    applyLazySwatches();
    applyGrid();
    applySelectors();
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    (window.requestAnimationFrame || setTimeout)(apply);
  }

  /*
   * Theme-fix: product-form crasht in updateSaleTextStandard als er geen
   * [data-price-off] in de sectie/pop-up staat (snel toevoegen, upsells).
   * Die crash breekt de rest van het formulier af, dus hier onschadelijk maken.
   */
  function patchProductForm() {
    var ProductForm = window.customElements && window.customElements.get('product-form');
    if (!ProductForm || ProductForm.prototype.__cvPatched) return;
    var original = ProductForm.prototype.updateSaleTextStandard;
    if (typeof original !== 'function') return;
    ProductForm.prototype.updateSaleTextStandard = function () {
      if (!this.priceOffWrap) return;
      try {
        return original.apply(this, arguments);
      } catch (e) {}
    };
    ProductForm.prototype.__cvPatched = true;
  }
  if (window.customElements) {
    patchProductForm();
    window.customElements.whenDefined('product-form').then(patchProductForm);
  }

  schedule();
  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length) {
        schedule();
        return;
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
